(() => {
  function init() {
    const root = document.getElementById('tc-site-navigation');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const nav = root.querySelector('.tc-site-nav');
    const search = root.querySelector('.tc-site-search');
    const menuButton = root.querySelector('[data-tc-site-menu]');
    const searchButton = root.querySelector('[data-tc-site-search]');
    const menus = [...nav.querySelectorAll(':scope > details')];
    const mobile = matchMedia('(max-width: 800px)');
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      document.body.appendChild(drawer);
      drawer.classList.add('tc-site-cart-moved');
    }
    const closeGroups = () => menus.forEach(menu => { menu.open = false; });
    function closeMenu(restoreFocus = false) {
      nav.classList.remove('is-open');
      menuButton.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('tc-site-navigation-open');
      if (restoreFocus) menuButton.focus();
    }
    function closeSearch() {
      search.classList.remove('is-open');
      searchButton.setAttribute('aria-expanded', 'false');
    }
    function responsiveGroups() {
      root.querySelectorAll('.tc-nav-group:not(div)').forEach(group => { group.open = !mobile.matches; });
      if (!mobile.matches) closeMenu();
    }
    responsiveGroups();
    mobile.addEventListener('change', responsiveGroups);
    menus.forEach(menu => menu.addEventListener('toggle', () => {
      if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
    }));
    menuButton.addEventListener('click', () => {
      closeSearch();
      const open = !nav.classList.contains('is-open');
      nav.classList.toggle('is-open', open);
      menuButton.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('tc-site-navigation-open', open);
      if (open) nav.querySelector('[data-tc-site-close]').focus();
    });
    root.querySelectorAll('[data-tc-site-close]').forEach(button => button.addEventListener('click', () => closeMenu(true)));
    searchButton.addEventListener('click', () => {
      closeMenu(); closeGroups();
      const open = !search.classList.contains('is-open');
      search.classList.toggle('is-open', open);
      searchButton.setAttribute('aria-expanded', String(open));
      if (open) search.querySelector('input[type=search]').focus();
    });
    root.querySelector('[data-tc-site-cart]').addEventListener('click', event => {
      const trigger = document.querySelector('.tamecare-cart-drawer__trigger');
      if (trigger) { event.preventDefault(); closeMenu(); closeSearch(); closeGroups(); trigger.click(); }
    });
    document.addEventListener('click', event => {
      if (!root.contains(event.target)) { closeSearch(); closeGroups(); }
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        const wasOpen = nav.classList.contains('is-open');
        closeMenu(wasOpen); closeSearch(); closeGroups();
      }
      if (event.key === 'Tab' && mobile.matches && nav.classList.contains('is-open')) {
        const focusable = [...nav.querySelectorAll('a[href],button,summary,input')].filter(el => el.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    nav.querySelectorAll('a[href]').forEach(link => {
      if (new URL(link.href).pathname === location.pathname) link.setAttribute('aria-current', 'page');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
